import { useState, useContext } from "react";
import styled from "styled-components";
import ModalContext from "components/contexts/ModalContext";
import client from "api/WookAxios";
import { naver, kakao, google, authorize } from "auth/DeprecatedOAuth";
import naverOAuth from "images/naverLogoButton.png";
import kakaoOAuth from "images/kakao_oauth_large.png";
import googleOAuth from "images/google_oauth.svg";
import { AiOutlineClose } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import useAuthenticate from "auth/useAuth";
import { AiOutlineRight } from 'react-icons/ai';
import consentList from "./consentList";

const ModalFrame = styled.div`
  // display: ${(props) => (props.$visible ? "flex" : "none")};
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  background: rgb(45, 49, 45, 0.5);
  z-index: 1010;
`;

const Modal = styled.div`
  box-sizing: border-box;
  position: relative;
  top: 80px;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  align-items: center;
  border-radius: 20px;
  width: 350px;
  height: 600px;
  margin: 0 auto;
  background: #fafbfa;
  background: white;
  opacity: 1;
`;

const Title = styled.div`
  // height: 40px;
  // background: red;
  width: 280px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 25px;
  font-weight: 500;
  color: #464646;
  // color: white;
  margin-top: 10px;
  // margin-left: 10px;
  margin-bottom: 10px;
  // background: black;
`;

const Container = styled.div`
  // background: red;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const Content = styled.div`
  width: 280px;
  height: 440px;
  background: Gainsboro;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 13px;
  font-weight: 600;
  white-space: pre-line;
  overflow: scroll;
  color: #464646;
  padding: 15px;
`;

const StatusBar = styled.div`
  box-sizing: border-box;  
  width: 280px;
  margin-top: 12px;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
  // background: red;
`;

const TextButton = styled.div`
  color: blue;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  &:hover {
    background: lightgray;
  }
`;

const ConsentDetailModal = ({ consentItem, onClose }) => {
  return (
    <div className="ConsentDetailModal">
      <ModalFrame>
        <Modal>
          <Title>{consentItem.title}</Title>
          <Container>
            <Content>
              {consentItem.content}
            </Content>
            <StatusBar><TextButton onClick={onClose}>뒤로</TextButton></StatusBar>
          </Container>  
        </Modal>
      </ModalFrame>
    </div>
  );
};

export default ConsentDetailModal;